import { Tracking } from '@panamax/app-state';
import { OrderAnalyticsMessages } from '../order-analytics.constants';
import { genericAnalyticsTransformer } from '@shared/tracking/analytics/generic-analytics-transformer';

export const cancelInProgressCartAnalytics = (
  orderId: string,
  origOrderId: string,
  products: any,
): Tracking => {
  return {
    analytics: {
      data: {
        event: OrderAnalyticsMessages.cancelInProgressOrderEvent,
        capability: OrderAnalyticsMessages.capability,
        order: {
          id: origOrderId || orderId,
          status: 'in progress',
        },
        products,
      },
      transformFunc: genericAnalyticsTransformer,
    },
  };
};
